import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ADD_USER, UserType, UsersStateType } from "./types";

const usersInitialState: UsersStateType = {
  data: [
    {
      id: 1,
      name: "Brandon Davidson",
      username: "brandon123",
      email: "brandon123@gmail",
      phone: "1234567890",
      status: "Active",
      userType: "Client User",
      client: "ABC Bank",
      role: "Admin, Primary Account",
      lastLogin: "01/01/2024",
    },
    {
      id: 2,
      name: "James Milner",
      username: "j.milner23",
      email: "j.milner23@gmail",
      phone: "1234567890",
      status: "Active",
      userType: "Inspection User",
      inspectionFirm: "XYZ Inspection",
      role: "Admin, Primary Account",
      lastLogin: "01/01/2024",
    },
    {
      id: 3,
      name: "Robert Mathew",
      username: "r.mathew12",
      email: "r.mathew12@gmail",
      phone: "1234567890",
      status: "Active",
      userType: "Internal User",
      role: "Admin, Primary Account",
      lastLogin: "01/01/2024",
    },
  ],
};

export const usersSlice = createSlice({
  name: ADD_USER,
  initialState: usersInitialState,
  reducers: {
    addUserAction: (
      state: UsersStateType,
      { payload: user }: PayloadAction<UserType>
    ) => {
      state.data.push(user);
    },
    addUserActionSuccess: (
      state: UsersStateType,
      { payload: user }: PayloadAction<UserType>
    ) => {
      console.log("Added user successfully!");
    },
  },
});

export const { addUserAction, addUserActionSuccess } = usersSlice.actions;
export default usersSlice.reducer;
